import { $window, $body } from '../../../../../../ig_template/Resources/Public/Src/Js/Constants';
import Map from '../../../../../../ig_map/Resources/Public/Src/Js/Elements/Map';

/**
 * Stores Map
 */
const StoresMap = (() => {
	// Constants
	const DATA_KEY = 'ig.store-locator';
	const EVENT_KEY = `.${DATA_KEY}`;

	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		STORES_MAP: '.stores-map-wrap',
		GOOGLE_MAP: '.ig-map',
		STORE_RESULTS: '.store-search-results',
		STORE_NAME: '.store-name'
	};

	/**
	 * Stores Map
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class StoresMap extends Map {
		/**
		 * @constructor
		 */
		constructor($element) {
			super($element);

			this.setMapSettings(eval(`IgStoreLocatorMapData${this._uid}`));
		}

		_addResultMarkerPan() {
			const $results = $body.find(Selector.STORE_RESULTS);

			if ($results.length) {
				const $storeNames = $results.find(Selector.STORE_NAME);
				const $map = $results.find(Selector.GOOGLE_MAP);
				const googleMap = $map.data('googleMap');
				const mapMarkers = $map.data('googleMapMarkers');

				$storeNames.each((i, el) => {
					$(el).on('click', (e) => {
						const markerUid = $(e.currentTarget).data('uid');
						const mapMarker = mapMarkers[markerUid];
						const infoWindow = this._getInfoWindowByUid(markerUid);
						googleMap.panTo(mapMarker.getPosition());

						if (infoWindow) {
							this._openInfoWindow(mapMarker, markerUid);
						}
					});
				});
			}
		}

		_mapMarkersAdded() {
			this._addResultMarkerPan();
		}
	}

	return StoresMap._getElements(Selector.STORES_MAP, StoresMap);
})();

export default StoresMap;
